// @core/api/endpoints/fiscalization/retry_fiscal_receipt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetryFiscalReceiptRequest,
  RetryFiscalReceiptResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Retry failed fiscal receipt
 * Retries submission of a failed or abandoned fiscal receipt to the provider.
 */
export async function RetryFiscalReceipt(
  id: string,
  data: RetryFiscalReceiptRequest,
  options?: RequestOptions
): Promise<RetryFiscalReceiptResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-receipts/:id/retry`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<RetryFiscalReceiptResponse>(requestPath, data, requestOptions);
}
